module.exports = __webpack_public_path__ + "static/media/edit-tools.28a883eb.svg";